import { FC } from 'react';
import { SectionDividerProps } from './types';
import { useSectionDividerController } from './SectionDivider.controller';
import useIsMobile from '@/hooks/use-is-mobile';
import { SectionDividerMobile } from './SectionDivider.mobile';
import { SectionDividerDesktop } from './SectionDivider.desktop';
export const SectionDivider: FC<SectionDividerProps> = ({ data, saveAnswer, goToNextSurveyItem }) => {
  const { title, text, orderNumber, isLoading, handleNextClick, imageId, navbarHeight } = useSectionDividerController({
    saveAnswer,
    data,
    goToNextSurveyItem,
  });

  const isMobile = useIsMobile();

  return isMobile ? (
    <SectionDividerMobile
      title={title}
      text={text}
      orderNumber={orderNumber}
      isLoading={isLoading}
      handleNextClick={handleNextClick}
      imageId={imageId}
      navbarHeight={navbarHeight}
    />
  ) : (
    <SectionDividerDesktop
      title={title}
      text={text}
      orderNumber={orderNumber}
      isLoading={isLoading}
      handleNextClick={handleNextClick}
      imageId={imageId}
      navbarHeight={navbarHeight}
    />
  );
};
